<se-fe-side-panel #sidePanel [seFeDataVisible]="showPanel" (seFeClose)="close()" (seFeAfterClose)="afterClose()">
  @if (activeDetail; as detail) {
    <se-fe-icon-button
      seFeSidePanelBack
      (click)="navigateBack()"
      [seFeDataButtonAttrs]="{ 'aria-label': (translateKey + 'DETAIL.back' | translate) }">
      <se-fe-icon seFeDataName="chevron_left" seFeDataSize="700"></se-fe-icon>
    </se-fe-icon-button>
  }
  <span seFeSidePanelActions>
    @if (sidePanelMenuOptions; as options) {
      <se-fe-button [seFeMenuTrigger]="sidePanelMenu">
        <se-fe-icon seFeDataName="more" seFeDataAriaLabel="more"></se-fe-icon>
      </se-fe-button>
      <se-fe-menu #sidePanelMenu [seFeDataOptions]="options"></se-fe-menu>
    }
  </span>
  @if (activeDetail; as detail) {
    @if (detail.title) {
      <se-fe-header
        seFeSidePanelHeader
        [seFeDataTitle]="detail.title"
        [seFeDataSubtitle]="detail.subtitle">
      </se-fe-header>
    }
  }
  <div seFeSidePanelContent>
    @if (profileAccessStatus === 'loading') {
      <se-fe-card>
        <se-po-profile-side-panel-header-skeleton></se-po-profile-side-panel-header-skeleton>
      </se-fe-card>
    } @else if (profileAccessStatus === 'denied') {
      <se-fe-alert
        seFeDataType="critical"
        [seFeDataHeader]="translateKey + 'ACCESS.denied' | translate">
      </se-fe-alert>
    } @else if (profileAccessStatus === 'error') {
      <se-fe-alert
        seFeDataType="critical"
        [seFeDataHeader]="translateKey + 'ACCESS.error' | translate">
      </se-fe-alert>
    } @else {
      @if (activeDetail; as detail) {
        <se-po-lazy-load
          [componentConfig]="activeDetailComponentConfig"
          [componentInputs]="detail.componentInputs"
          [componentOutputs]="detailComponentOutputs">
        </se-po-lazy-load>
      }
      <div [hidden]="activeDetail">
        @if (vm$ | async; as vm) {
          <se-fe-card>
            @if (vm.headerLoaded) {
              <se-fe-card-header>
                <div seFeCardHeaderTitle>
                  {{ vm.title }}
                </div>
                @if (vm.verifiedInfoFields.length) {
                  <div seFeCardHeaderSubtitle>
                    <span [seFeTooltipTrigger]="verifiedInfoTooltip">
                      <se-fe-icon
                        seFeDataName="badge_verify_fill"
                        seFeDataColor="on"
                        [seFeDataAriaLabel]="translateKey + 'IDENTITY.VERIFIED_INFO.title' | translate">
                      </se-fe-icon>
                        {{ translateKey + 'IDENTITY.VERIFIED_INFO.title' | translate: { date: (vm.verifiedInfo?.approved_at | seFeDate) } }}
                    </span>
                    <se-fe-tooltip #verifiedInfoTooltip>
                      {{
                        translateKey + 'IDENTITY.VERIFIED_INFO.tooltip'
                          | translate: {
                            fields: (vm.verifiedInfoFields | readableList)
                          }
                      }}
                    </se-fe-tooltip>
                  </div>
                }
                <div seFeCardHeaderActions>
                  @if (vm?.pendingProfile) {
                    <se-fe-chip
                      [seFeDataText]="translateKey + 'IDENTITY.INVITE_STATUS.' + vm.inviteStatus | translate"
                      [seFeMenuTrigger]="inviteMenu">
                    </se-fe-chip>
                    <se-fe-menu #inviteMenu [seFeDataOptions]="pendingMenuOptions"></se-fe-menu>
                  }
                  @if (vm?.editable) {
                    <se-fe-button class="identity-header-edit" (click)="openEditPersona(vm, $event)">
                      {{ translateKey + 'IDENTITY.edit' | translate }}
                    </se-fe-button>
                  }
                </div>
                <div seFeCardHeaderVisual>
                  @if (vm?.title) {
                    <se-fe-avatar
                      seFeDataType="persona"
                      [seFeDataIdentity]="vm.title"
                      [seFeDataImgUrl]="vm.avatar"
                      seFeDataSize="500">
                    </se-fe-avatar>
                  }
                </div>
              </se-fe-card-header>
            } @else {
              <se-po-profile-side-panel-header-skeleton></se-po-profile-side-panel-header-skeleton>
          }

          @if (vm.headerLoaded) {
            <se-fe-card-content>
              <div class="identity-header-content">
                <ng-container [ngTemplateOutlet]="vm?.isAdmin ? adminTpl : personaTpl"
                  [ngTemplateOutletContext]="{ $implicit: vm }" />
              </div>
            </se-fe-card-content>
          }

          <se-fe-card-content>
            <se-po-lazy-load-group
              class="profile-side-panel__modules"
              [modules]="currentModules"
              [hostReady]="vm.headerLoaded"
              [moduleConfigs]="moduleConfigs"
              [componentInputs]="profileFeatureInputs$ | async"
              [componentOutputs]="profileComponentOutputs">
            </se-po-lazy-load-group>
          </se-fe-card-content>
        </se-fe-card>
      }
      </div>
    }
  </div>
</se-fe-side-panel>

<ng-template #adminTpl let-vm>
  <se-fe-grid seFeGridOpts="snug">
    <se-fe-grid-cell seFeGridOpts>
      <se-fe-label-value-pair>
        <span seFeLabel>{{ translateKey + 'IDENTITY.roles' | translate }}</span>
        <span seFeValue>{{ vm.roles }}</span>
      </se-fe-label-value-pair>
    </se-fe-grid-cell>
      <se-fe-grid-cell seFeGridOpts>
      <se-fe-label-value-pair>
        <span seFeLabel>{{ translateKey + 'IDENTITY.access' | translate }}</span>
        <span seFeValue>{{ vm.access }}</span>
      </se-fe-label-value-pair>
    </se-fe-grid-cell>
  </se-fe-grid>
</ng-template>

<ng-template #personaTpl let-vm>
  <se-fe-grid seFeGridOpts="snug">
    @if (vm.verifiedInfoMismatch && showMismatchAlert) {
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell seFeGridOpts>
          <se-fe-alert seFeDataType="caution" [seFeDismissible]="true" (seFeDismiss)="showMismatchAlert = false">
            {{ translateKey + 'IDENTITY.VERIFIED_INFO.mismatch_title' | translate: { mismatch: (vm.verifiedInfoMismatchedFields | readableList) } }}
            <se-fe-alert-subheader>
              {{ translateKey + 'IDENTITY.VERIFIED_INFO.mismatch_subtitle' | translate }}
            </se-fe-alert-subheader>
          </se-fe-alert>
        </se-fe-grid-cell>
      </se-fe-grid>
    }
    <se-fe-grid-cell seFeGridOpts>
      <se-fe-label-value-pair>
        <span seFeLabel>{{ translateKey + 'IDENTITY.dob' | translate }}</span>
        <span seFeValue>
          @if (vm.dob) {
            {{ vm.dob | seFeShortDate }}
          } @else { -- }
        </span>
      </se-fe-label-value-pair>
    </se-fe-grid-cell>
      <se-fe-grid-cell seFeGridOpts>
      <se-fe-label-value-pair>
        <span seFeLabel>{{ translateKey + 'IDENTITY.age' | translate }}</span>
        <span seFeValue>{{ vm.age }}</span>
      </se-fe-label-value-pair>
    </se-fe-grid-cell>
    @if (vm.persona?.graduation_year) {
      <se-fe-grid-cell seFeGridOpts>
        <se-fe-label-value-pair>
          <span seFeLabel>{{ translateKey + 'IDENTITY.graduates' | translate }}</span>
          <span seFeValue>{{ vm.graduationYear }}</span>
        </se-fe-label-value-pair>
      </se-fe-grid-cell>
    }
    <se-fe-grid-cell seFeGridOpts>
      <se-fe-label-value-pair>
        <span seFeLabel>{{ translateKey + 'IDENTITY.gender' | translate }}</span>
        <span seFeValue>{{ vm.gender | titlecase }}</span>
      </se-fe-label-value-pair>
    </se-fe-grid-cell>
  </se-fe-grid>
  @if (vm?.persona?.type === 'other') {
    <ng-container *ngTemplateOutlet="contactInfoTpl; context: { $implicit: vm }"></ng-container>
  }
</ng-template>

<ng-template #contactInfoTpl let-vm>
  @if (vm.headerLoaded) {
    <se-fe-grid seFeGridOpts="snug">
      <se-fe-grid-cell seFeGridOpts>
        <se-fe-accordion seFeDataSmall="true" [seFeDataSnug]="true" seFeDataHeadingLevel="2"
          [seFeDataTitle]="translateKey + 'IDENTITY.contact_info' | translate">
          <ng-template seFeAccordionContent>
            <se-fe-grid seFeGridOpts="snug justified">
              <se-fe-grid-cell seFeGridOpts="grow">
                <se-fe-label-value-pair>
                  <span seFeLabel>{{ translateKey + 'IDENTITY.phone' | translate }}</span>
                  <span seFeValue>{{ vm.phone | phone}}</span>
                </se-fe-label-value-pair>
              </se-fe-grid-cell>
              <se-fe-grid-cell seFeGridOpts="grow">
                <se-fe-label-value-pair>
                  <span seFeLabel>{{ translateKey + 'IDENTITY.email' | translate }}</span>
                  <span seFeValue>{{ vm.email }}</span>
                </se-fe-label-value-pair>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="snug">
              <se-fe-grid-cell seFeGridOpts>
                <se-fe-label-value-pair>
                  <span seFeLabel>{{ translateKey + 'IDENTITY.address' | translate }}</span>
                  <span seFeValue>{{ vm.address }}</span>
                </se-fe-label-value-pair>
              </se-fe-grid-cell>
            </se-fe-grid>
          </ng-template>
        </se-fe-accordion>
      </se-fe-grid-cell>
    </se-fe-grid>
  }
</ng-template>
